import CheckIcon from 'vux/src/components/check-icon/index.vue'

export default {
name: 'logoutApply',
components: {
CheckIcon
},
data () {
return {
isAgree: true
}
},
methods: {
logoutNotice () {
this.$router.push({
path: '/logoutAgreement'
})
},
readAgree () {
this.$vux.toast.show({
type: 'warn',
text: '请阅读并同意《注销须知》'
})
},
createLogout () {
this.$request.post('/user/logoutExamine',{

}).then(data => {
if(data.code == 0){
this.$router.push({
path: '/logoutVerify'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
apply () {
this.$request.post('/user/checkLogoutUser',{

}).then(data => {
console.log(data)
if(data.code == 0){
if(data.obj.status){
this.createLogout()
}else{
this.$router.push({
path: '/logoutCannot'
})
}
}else{
this.$vux.toast.show({
type: 'warn',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
},
created () {

},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/views/logoutApply/script.js